import React from "react";
import Dropzone from "react-dropzone";
import { Typography, Grid, makeStyles } from "@material-ui/core";
import { UploadCloud } from "react-feather";
import PropTypes from "prop-types";
import { LIGHT_GRAY_COLOR, SECONDARY_COLOR } from "../../theme";

const DropzoneArquivos = props => {
    const {
        extrapolaQuantidadeMaxArquivos,
        quantidadeMaximaDeArquivos,
        tamanhoMaximoDoArquivo,
        onUploadSuccess,
        onUploadError,
        tiposAceitos,
        desabilitado,
        className,
        singleFile
    } = props;

    const classes = useStyles();

    const arquivosCarregadosComSucesso = [];

    const aoDroparArquivo = arquivos => {
        if (arquivos.length <= quantidadeMaximaDeArquivos) {
            arquivos.forEach(arquivo => {
                if (arquivosCarregadosComSucesso.length < quantidadeMaximaDeArquivos) {
                    arquivosCarregadosComSucesso.push(arquivo);
                }
            });
            onUploadSuccess(arquivosCarregadosComSucesso);
        } else {
            extrapolaQuantidadeMaxArquivos();
        }
    };

    const erroAoCarregar = arquivo => onUploadError(arquivo);

    return (
        <>
            <Dropzone
                minSize={1}
                maxSize={tamanhoMaximoDoArquivo * 1024 * 1024}
                accept={tiposAceitos}
                multiple={singleFile===false}
                onDropRejected={arquivo => erroAoCarregar(arquivo)}
                onDrop={arquivos => aoDroparArquivo(arquivos)}
                disabled={desabilitado}
            >
                {({ getRootProps, getInputProps }) => (
                    <div
                        className={`${className} ${classes.dropzone} ${desabilitado ? classes.dropZoneDesabilitado : ""}`}
                        {...getRootProps()}
                    >
                        <input {...getInputProps()} />
                        <Grid
                            container
                            direction="column"
                            justify="center"
                            alignItems="center"
                            className={classes.container}
                        >
                            <Grid item>
                                <UploadCloud className={`mt-1 ${desabilitado ? classes.corLightGray : ""}`} />
                            </Grid>
                            <Grid item>
                                <Typography
                                    align="center"
                                    className={`${desabilitado ? classes.corLightGray : ""}`}
                                >
                                    Arraste e solte seus arquivos aqui ou
                  <span className={desabilitado ? classes.corLightGray : classes.clique}>
                                        {" clique "}
                                    </span>
                  para selecionar
                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                )}
            </Dropzone>
        </>
    );
};

const useStyles = makeStyles(theme => ({
    dropzone: {
        borderStyle: "dashed",
        borderWidth: "1px",
        cursor: "pointer",
    },
    container: {
        minHeight: theme.spacing(12)
    },
    clique: {
        color: SECONDARY_COLOR
    },
    corLightGray: {
        color: LIGHT_GRAY_COLOR
    },
    dropZoneDesabilitado: {
        cursor: "not-allowed",
        borderColor: LIGHT_GRAY_COLOR
    }
}));

DropzoneArquivos.propTypes = {
    /** Define os tipos de arquivos aceitos. Acesse o seguinte link pra saber como passar cada tipo -> https://react-dropzone.js.org/#!/Accepting%20specific%20file%20types */
    tiposAceitos: PropTypes.string,
    /** Define a quantidade máxima de arquivos que podem ser enviados. */
    quantidadeMaximaDeArquivos: PropTypes.number,
    /** Define o tamanho máximo que um arquivo deve ter pra ser aceito. */
    tamanhoMaximoDoArquivo: PropTypes.number,
    /** Função chamada quando há algum problema no upload do arquivo */
    onUploadError: PropTypes.func,
    /** Função chamada quando o arquivo é enviado com sucesso */
    onUploadSuccess: PropTypes.func,
    /** Função chamada quando a quantidade máxima de arquivos é extrapolada */
    extrapolaQuantidadeMaxArquivos: PropTypes.func,
    /** Define se o dropzone estará desabilitado */
    desabilitado: PropTypes.bool
};

DropzoneArquivos.defaultProps = {
    quantidadeMaximaDeArquivos: 999,
    tiposAceitos: ".jpeg, .png, .pdf, .jpg",
    extrapolaQuantidadeMaxArquivos: null,
    tamanhoMaximoDoArquivo: 5,
    onUploadError: null,
    onUploadSuccess: null,
    desabilitado: false
};

export default DropzoneArquivos;
